export const COMPONENT_NAME = "application-wallet-confirm";
